import { bindable } from 'aurelia-framework';

class ProductDetail {
  @bindable detail = [];
  @bindable onCategory = false;
  @bindable images = [];
  @bindable links = [];
  shouldBeImage = {};
  shouldBeLink = {};
  imagesChanged(images) {
    this.shouldBeImage = this._toObject(images);
  }
  linksChanged(links) {
    this.shouldBeLink = this._toObject(links);
  }
  _toObject(list) {
    return list && list.length ?
      list.reduce(
        (newObject, property) => Object.assign({}, newObject, {
          [property]: true,
        }),
        {},
      ) :
      {};
  }
}

export { ProductDetail };
